// extracted by mini-css-extract-plugin
export var labelWrapper = "_df-0";